module.exports = __webpack_public_path__ + "assets/images/dk-login-background.png";